<template>
  <button :class="['primaryButton', { primaryButton__contractButton: isContractButton }]" @click="click" v-bind="$attrs">
    <span class="primaryButton__content">
      <slot />
    </span>
  </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CommonButtonPrimary',
  emits: ['click'],
  props: {
    isContractButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    },
  },
});
</script>

<style lang="stylus" scoped>
.primaryButton {
  padding: 12px 16px;
  user-select: none;

  &__contractButton {
    padding: 8px 15px;
  }

  +mediaTablet() {
    padding: 13px 16px;
    &__contractButton {
      padding: 8px 15px;
    }
  }

  border-radius: 4px;
  color: $colorFiller;
  background-color: $colorPrimary;
  border: 0;
  cursor: pointer;
  transition: all 0.1s;
  getFontButton();

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: default;

    >span {
      opacity: 0.2;
    }
  }

  &:hover {
    opacity: 0.8;
  }

  &__content {
    opacity: 1;
  }
}
</style>
